module.exports = "ng-select {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/insights/profilesPerGeo/profilesPerGeo.component.scss
// module id = 566
// module chunks = 1